<template>
	<app-panel class="mt-3" compact>
		<nav aria-label="Progress" class="flex justify-center py-4">
			<ol role="list" class="flex items-center pb-5">
				<li
					v-for="(step, stepIdx) in steps"
					:key="step.name"
					:class="[stepIdx !== steps.length - 1 ? 'pr-10 sm:pr-24' : '', 'relative']">
					<template v-if="current > stepIdx + 1">
						<div class="absolute inset-0 flex items-center" aria-hidden="true">
							<div class="h-0.5 w-full bg-blue-600" />
						</div>
						<router-link
							:to="step.href"
							class="relative flex h-8 w-8 items-center justify-center rounded-full"
							:class="isComplete(stepIdx + 1) ? 'bg-blue-600' : 'bg-red-500'">
							<ExclamationTriangleIcon
								v-if="!isComplete(stepIdx + 1)"
								class="h-5 w-5 text-white"
								aria-hidden="true" />
							<CheckIcon v-else class="h-5 w-5 text-white" aria-hidden="true" />
							<span :class="stepLabel">{{ step.name }}</span>
						</router-link>
					</template>
					<template v-else-if="current == stepIdx + 1">
						<div class="absolute inset-0 flex items-center" aria-hidden="true">
							<div class="h-0.5 w-full bg-gray-200" />
						</div>
						<router-link
							:to="step.href"
							class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-600 bg-white"
							aria-current="step">
							<span
								class="h-2.5 w-2.5 rounded-full bg-blue-600"
								aria-hidden="true"
								data-testid="current-indicator" />
							<span :class="stepLabel">{{ step.name }}</span>
						</router-link>
					</template>
					<template v-else>
						<div class="absolute inset-0 flex items-center" aria-hidden="true">
							<div class="h-0.5 w-full bg-gray-200" />
						</div>
						<router-link
							:to="step.href"
							class="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white">
							<CheckIcon
								v-if="isComplete(stepIdx + 1)"
								class="h-5 w-5 text-gray-200"
								aria-hidden="true" />
							<!-- <span
								class="h-2.5 w-2.5 rounded-full bg-transparent"
								aria-hidden="true" /> -->
							<span :class="stepLabel">{{ step.name }}</span>
						</router-link>
					</template>
				</li>
			</ol>
		</nav>
	</app-panel>
</template>

<script lang="ts" setup>
	import { CheckIcon, ExclamationTriangleIcon } from '@heroicons/vue/20/solid'
	import useDriverApp from '@/stores/driver-app'

	// Resources
	const store = useDriverApp()

	withDefaults(
		defineProps<{
			current: number
		}>(),
		{
			current: 1
		}
	)

	const steps = [
		{ name: 'Check', href: 'details' },
		{ name: 'Photo', href: 'photo' },
		{ name: 'Signature', href: 'signature' },
		{ name: 'Survey', href: 'survey' },
		{ name: 'Confirm', href: 'confirm' }
	]

	const stepLabel = 'absolute top-full mt-2 text-xs text-gray-600'

	function isComplete(step: number) {
		switch (step) {
			case 1:
				return store.step1Complete
			case 2:
				return store.step2Complete
			case 3:
				return store.step3Complete
			case 4:
				return store.step4Complete
			default:
				return true
		}
	}
</script>
